import React, { memo, useEffect, useRef, useState } from "react";
import Header from "../../layout/Header";
import { ValidatorForm } from "react-form-validator-core";
import TextValidator from "../../partial/TextValidator";
import { getPromotion, postProduct, updateProductData, } from "../../../actions/auth";
import { decrypt } from "../../../utils/encodingdecoding";
import Page from "./Pagination";
import swal from "sweetalert";

const ProductManagement = () => {
    const [loader, setLoader] = useState(false);
    const [state, setState] = useState({
        file: "",
        error: true,
        errorMsg: "Note:- Only .csv type files are supported.",
    });
    const [currentPage, setCurrentPage] = useState(0);
    const [response, setResponse] = useState([]);
    const [editRowId, setEditRowId] = useState(null);
    const [editData, setEditData] = useState({});

    const { file, error, errorMsg } = state;
    const pageSize = 10;
    const pageCount = Math.ceil(response?.length / pageSize);

    const fileInputRef = useRef(null);

    const onChange = (e) => {
        if (e.target.files[0]?.type?.includes("csv")) {
            setState({ ...state, file: e.target.files[0], error: false });
        } else {
            setState({ ...state, error: true });
        }
    };

    const fetchOffer = async () => {
        setLoader(true);
        const token = JSON.parse(localStorage.getItem("token_gen"));
        const Id = decrypt(localStorage.getItem("Id"));
        try {
            const res = await getPromotion(token?.access_token, Id);
            setResponse(res.data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchOffer();
    }, []);

    const onSubmit = async () => {
        if (file) {
            const token = JSON.parse(localStorage.getItem("token_gen"));
            const Id = decrypt(localStorage.getItem("Id"));
            setLoader(true);
            try {
                await postProduct(file, token?.access_token, Id).then((res) => {
                    if (res.message == "Success") {
                        fileInputRef.current.value = "";
                        setState({
                            file: "",
                            error: false,
                            errorMsg: "Note:- Only .csv type files are supported.",
                        });
                        fetchOffer();
                        swal({
                            position: "center",
                            icon: "success",
                            title: "Product uploaded successfully",
                            showConfirmButton: false,
                            timer: 3000,
                        });
                    } else {
                        swal({
                            position: "center",
                            icon: "error",
                            title: "Product not uploaded ",
                            showConfirmButton: false,
                            timer: 3000,
                        });
                    }
                })

            } catch (err) {
                console.error(err);
            } finally {
                setLoader(false);
            }
        } else {
            setState({ ...state, error: true, errorMsg: "Please upload a file" });
        }
    };

    const handleEdit = (id) => {
        const data = response.find((item) => item.id === id);
        setEditRowId(id);
        setEditData(data);
    };

    const handleInputChange = (key, value) => {
        setEditData((prev) => ({ ...prev, [key]: value }));
    };

    const handleSave = async () => {
        setLoader(true)
        const token = JSON.parse(localStorage.getItem("token_gen"));
        try {
            await updateProductData(token?.access_token, editRowId, editData,).then((res) => {
                if (res.message == "Success") {
                    setEditRowId(null);
                    setLoader(false)
                    swal({
                        position: "center",
                        icon: "success",
                        title: "Product data updated successfully",
                        showConfirmButton: false,
                        timer: 3000,
                    });
                    fetchOffer();
                }
                else {
                    swal({
                        position: "center",
                        icon: "error",
                        title: "Product data not updated",
                        showConfirmButton: false,
                        timer: 3000,
                    });
                }
            })

        } catch (err) {
            console.error(err);

        }
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const date = new Date(dateStr);
        return date.toLocaleDateString("en-GB"); // DD-MM-YYYY
    };
    const handleCancel = () => {
        setEditRowId(null);
        setEditData({});
    };

    return (
        <>
            <Header name={"Product Management"} />
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        {[...Array(8)].map((_, i) => (
                            <div key={i}></div>
                        ))}
                    </div>
                </div>
            )}
            <div className='dashboard__content'>
                <ValidatorForm onSubmit={onSubmit} className="dashboard__customerViewMain">
                    <div className="dashboard__transactionsCard">
                        <div className="dashboard__header">
                            <div className="dashboard__left">
                                <h4>Upload Product</h4>
                            </div>
                        </div>
                        <div className='dashboard__customerViewCard'>
                            <div className='row'>
                                <div className="col-md-4">
                                    <div className="uploadingExistingData__uploadBoxUploadFile">
                                        <form encType="multipart/form-data">
                                            <input
                                                ref={fileInputRef}
                                                className="form-control"
                                                placeholder="Uploaded File"
                                                type="file"
                                                accept=".csv"
                                                onChange={onChange}
                                            />
                                            {error && <span style={{ color: "red" }}>{errorMsg}</span>}
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className='customer_group_form'>
                                <button type='submit' className="btn btn-primary">
                                    Upload
                                </button>
                            </div>
                        </div>
                    </div>
                </ValidatorForm>

                <div className="dashboard__customersCard">
                    <div className="dashboard__header">
                        <div className="dashboard__left">
                            <h4>Product List</h4>
                        </div>
                    </div>
                    <div className="dashboard__body">
                        {Array.isArray(response) && response.length > 0 ? (
                            <div>
                                <div style={{ overflowX: "auto" }}>
                                    <table className="table table-bordered" style={{ minWidth: "1000px" }}>
                                        <thead>
                                            <tr>
                                                {Object.keys(response[0])
                                                    .filter((key) =>
                                                        !["merchantCode", "createdAt", "discriminator", "productMasterFile", "updatedAt", "_rid", "_self", "_etag", "_attachments", "_ts", "id"].includes(key)
                                                    )
                                                    .map((key) => (
                                                        <th key={key}>{key}</th>
                                                    ))}
                                                <th style={{ position: "sticky", zIndex: 5, right: 0, background: "white" }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {response
                                                .slice(currentPage * pageSize, (currentPage + 1) * pageSize)
                                                .map((item) => (
                                                    <tr key={item.id}>
                                                        {Object.entries(item)
                                                            .filter(([key]) =>
                                                                !["merchantCode", "createdAt", "discriminator", "productMasterFile", "updatedAt", "_rid", "_self", "_etag", "_attachments", "_ts", "id"].includes(key)
                                                            )
                                                            .map(([key, value]) => (
                                                                <td key={key}>
                                                                    {editRowId === item.id && key !== "createdAt" ? (
                                                                        <input
                                                                            className="editData"
                                                                            value={editData[key] || ""}
                                                                            onChange={(e) => handleInputChange(key, e.target.value)}
                                                                        />
                                                                    ) : key === "createdAt" ? (
                                                                        formatDate(value)
                                                                    ) : typeof value === "object" && value !== null ? (
                                                                        JSON.stringify(value)
                                                                    ) : (
                                                                        value
                                                                    )}
                                                                </td>
                                                            ))}
                                                        <td style={{ position: "sticky", zIndex: 1, right: 0, background: "white" }}>
                                                            {editRowId === item.id ? (
                                                                <div style={{ display: "flex", justifyContent: "center", }}>
                                                                    <button className="btn btn-sm btn-success" onClick={handleSave}>
                                                                        Save
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-sm btn-secondary"
                                                                        onClick={handleCancel}
                                                                        style={{ marginLeft: "5px" }}
                                                                    >
                                                                        Cancel
                                                                    </button>
                                                                </div>
                                                            ) : (
                                                                <div style={{ display: "flex", justifyContent: "center" }}>
                                                                    <button
                                                                        className="btn btn-sm btn-outline-primary"
                                                                        onClick={() => handleEdit(item.id)}
                                                                    >
                                                                        Edit
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="dashboard__paginationBox mt-2">
                                    <Page currentPage={currentPage} setCurrentPage={setCurrentPage} pageCount={pageCount} value={5} />
                                </div>
                            </div>
                        ) : (
                            <p>No data found</p>
                        )}

                    </div>
                </div>
            </div>
        </>
    );
};

export default ProductManagement;
